import { render, staticRenderFns } from "./conflicting_reputations.vue?vue&type=template&id=0ed9afa8&"
import script from "./conflicting_reputations.vue?vue&type=script&lang=js&"
export * from "./conflicting_reputations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports